// Copyright © 2022 Daniel Morris
//
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at:
//
// https://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.
import { RestClient } from 'typed-rest-client';
const interpolateEndpoint = (endpoint, params) => {
    return endpoint.replace('{id}', params[0] ?? '');
};
export class SportmonksClient {
    constructor(options) {
        this.options = options;
        this.get = async (endpoint, options) => {
            const interpolatedEndpoint = interpolateEndpoint(endpoint, options);
            const response = await this.rc.get(this.getApiPath() + interpolatedEndpoint, { queryParameters: { params: { api_token: this.options.apiToken } } });
            return response.result.data;
        };
        this.rc = new RestClient(this.options.userAgent, this.getBaseUrl());
    }
}
